import script from "./ShippingUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingUpdate.vue?vue&type=script&setup=true&lang=js"

import "./ShippingUpdate.vue?vue&type=style&index=0&id=0281475a&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0281475a"]])

export default __exports__